import { Link } from 'react-router-dom';
import { MultiImagesDisplayContainer } from './multi-images-display.styles';

const MultiImagesDisplay = ({ displays = [] }) => {

    return (
        <MultiImagesDisplayContainer>
            {
                displays.map((display, i) => <Link to={''}
                            key={i} 
                            className='display' 
                            >
                            <div className='display-frame'  style={{
                                backgroundImage: `url(${display.img})`,
                             }}>
                                <span className="header-info">
                                    <h2>{display.title}</h2>
                                    <p>{display.subtitle}</p>
                                </span>
                            </div>
                            
                    </Link>
                )
            }
        </MultiImagesDisplayContainer>
    )
}

export default MultiImagesDisplay;